import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultRoiReportMonth } from '../../../api/pleri-roi-reports';

export const Route = createFileRoute('/settings/roi-reports/')({
  beforeLoad: () => {
    throw redirect({
      to: '/settings/roi-reports/$month',
      params: { month: getDefaultRoiReportMonth() },
    });
  },
  component: () => null,
});
